import "./RateLimitPage.scss";

import React, { useEffect, useState } from "react";
import { useSelector } from "utils/redux";
import { getSessionId, logToSentry } from "utils/sentry";

const RATE_LIMIT_DURATION = 60; // 60 seconds

const RateLimitPage = () => {
  const uiSessionId = getSessionId();
  const loggedInUser = useSelector((state) => state.main.loggedInUser);
  const userId = loggedInUser?.id || "unknown";
  const userEmail = loggedInUser?.email || "unknown";

  const [countdown, setCountdown] = useState(RATE_LIMIT_DURATION);

  useEffect(() => {
    logToSentry(`Rate Limit Page`, "warn", {
      uiSessionId,
      url: window.location.href,
      userId,
      userEmail,
    });
  }, [loggedInUser, uiSessionId, userId, userEmail]);

  useEffect(() => {
    if (countdown <= 0) {
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown]);

  const handleGoHome = () => {
    // do a full page refresh to ensure clean state
    window.location.href = "/";
  };

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    if (mins > 0) {
      return `${mins}:${secs.toString().padStart(2, "0")}`;
    }
    return `${secs} seconds`;
  };

  return (
    <div className="rate-limit-page">
      <div className="rate-limit-content">
        <div className="rate-limit-logo">
          <img
            className="img"
            src="/static/images/logo-purple.png"
            alt="KAboodle Logo"
          ></img>
        </div>

        <div className="rate-limit-title">High Activity Detected</div>

        <div className="rate-limit-description">
          <p>
            We've noticed an unusually high number of requests from your
            account. To ensure optimal performance for all users, please wait a
            minute before continuing.
          </p>
        </div>

        <div className="flex ac-c jc-c" style={{ gap: "16px" }}>
          <button
            onClick={handleGoHome}
            className="button undefined"
            disabled={countdown > 0}
          >
            {countdown > 0
              ? `Try Again (${formatTime(countdown)})`
              : "Try Again"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RateLimitPage;
